import {required} from "vuelidate/lib/validators";  
import moment from 'moment' 
const StrKontrolTanim = {
    data() {
      return { 
        StrKontrolTanimData:{ 
          SiraNo:"",
          UstDonemId:"",
          StandartId:"", 
          EylemId:"", 
          TamamlanmaTarihi:"",  
          TamamlanmaAciklama:"",
          Sonuc:"",
          Deleted:false,  
        },  
          FormDataType:{ 
            SiraNo:{FieldName:"Sirano",Field:"input",FieldTitle:this.$t('StrKontrolTanim.AddEdit.SiraNo')},
            UstDonemId:{FieldName:"UstDonemId",Field:"combobox",FieldTitle:this.$t('StrKontrolTanim.AddEdit.UstDonemId'),ComboDataArray:[]}, 
            StandartId:{FieldName:"StandartId",Field:"combobox",FieldTitle:this.$t('StrKontrolTanim.AddEdit.StandartId'),ComboDataArray:[]}, 
            EylemId:{FieldName:"EylemId",Field:"combobox",FieldTitle:this.$t('StrKontrolTanim.AddEdit.EylemId'),ComboDataArray:[]}, 
            TamamlanmaTarihi:{FieldName:"TamamlanmaTarihi",Field:"date",FieldTitle:this.$t('StrKontrolTanim.AddEdit.TamamlanmaTarihi')},
            TamamlanmaAciklama:{FieldName:"TamamlanmaAciklama",Field:"textarea",FieldTitle:this.$t('StrKontrolTanim.AddEdit.TamamlanmaAciklama')},
            Sonuc:{FieldName:"Sonuc",Field:"textarea",FieldTitle:this.$t('StrKontrolTanim.AddEdit.Sonuc')},
          
          }   
      }
    },
    validations:{ 
      FormData: {
          SiraNo: { required }, 
          UstDonemId: { required }, 
          StandartId: { required }, 
          EylemId: { required }, 
          TamamlanmaTarihi: { required }, 
          TamamlanmaAciklama:{  },
          Sonuc : {  }, 
      }
 
  },
  created(){  
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };


    let sorgu = "&Tip=1561";
    let Tip=[];
      
      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
        console.log(res)
          for(var i=0; i<res.Data.length; i++)
          {   
              if(res.Data[i].Kod==3 ) { 

                  Tip.push(res.Data[i].Id);       

              } 
             
          }

          let altsorgu="&UstIdDoluMu=false&Approval=true";

          let tipler="";

          for (var s=0; s<Tip.length; s++){

              tipler=tipler+"&TipId="+Tip[s];

          }

          altsorgu=altsorgu+tipler;



          this.ActionsFilterGet({"Service":"StrPerfDonem", "Page":Page,Filter:altsorgu}).then((res) => { 
            let Tarih= moment(new Date()).format('YYYY-MM-DD');
            for (var i = 0; i < res.Data.length; i++) { 
              if(this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= Tarih && Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)){
                
                  this.FormDataType.UstDonemId.ComboDataArray.push({
                  Id: res.Data[i].Id,
                  Value: res.Data[i].Aciklama,
                });
              
              }
            }
          });
        });




    this.ActionsFilterGet({"Service":"StrKontrolStandart", "Page":Page, "Filter": "&Asc=Sirano"}).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.StandartId.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].StandartKodNo+" "+res.Data[i].StandartGenelSarti,
        });
      }
    });
    this.ActionsFilterGet({"Service":"StrKontrolEylem", "Page":Page, "Filter": "&Asc=Sirano"}).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.EylemId.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Kod+" "+res.Data[i].Eylem,
        });
      }
    });
  }
}
export default StrKontrolTanim